module.exports = __webpack_public_path__ + "static/img/afmLocation1.83900f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/afmLocation1.png
// module id = d1Cc
// module chunks = 1